import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form"
import CustomSearchSelect from '../CustomSearchSelect'
import Grid from "@mui/material/Unstable_Grid2";

const ModalSubdisciplina = ({open, handleClose, subdisciplinas, onSubmit}) => {

    const defaultValues = {
        new_subdisciplina: null,
    }

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }


    return (
        <Dialog
            open={open}
            onClose={() => handleClose()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='md'
            fullWidth={true}
        >
            <DialogTitle>Información adicional</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                            <CustomSearchSelect
                                options={subdisciplinas}
                                type="text"
                                name="new_subdisciplina"
                                lab="Subdisciplina"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                    <Typography sx={{fontWeight:'bold'}}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{fontWeight:'bold'}}>Actualizar</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalSubdisciplina